class TextSplitter {

	constructor(el, params) {

		// core vars

		this.$el = $(el);
		this.params = params;

		// param vars

		// This adds line and word classes to each element, making it easier to detect the positioning of objects
		// without having to make a new TextSplitter().
		// If your text is looking weird, make sure the FONT IS LOADED FIRST!

		this._defaults = {

			type: 'words,lines',

			// label classes

			charsClass: 'char',
			wordsClass: 'word',
			linesClass: 'line',

			// word delimiter

			wordDelimiter: ' ',

			// double-wrap divs for masking or animation effects

			doubleWrapLine: false,
			doubleWrapWord: false,
			doubleWrapChar: false,

			// check window resize and rebuild

			responsive: true
		}

		this._options = this._mergeDefaults(params);

		// main split var

		this._split;

		// don't allow splitting too often (that's stilly)

		this._splitThrottler = _.throttle(this._splitText, 400);

		// flags

		this._isEnabled = false;

		//

		$(() => {
			this._onDomReady();
		});
	}

	// listeners linked to public methods

	_addModuleAccess(){

		// events linked to methods (do this often)

		this.$el.on('enable', this.enable.bind(this));
		this.$el.on('disable', this.disable.bind(this));
		this.$el.on('revert', this.revert.bind(this));

		// link to module from $el object (use with caution)

		if(!this.$el[0].modules){ this.$el[0].modules = {}; }
		this.$el[0].modules.simpleSlider = this;
	}

	// private methods

	_onDomReady(){
		this._addModules();
		this._addListeners();
		this.enable();
	}

	_addModules(){

	}

	// listeners

	_addListeners(){
		window.vent.on('domUpdate', this._onDomUpdate, this);
		window.vent.on('windowResize', this._onResize, this);
	}

	_removeListeners(){

	}

	// listener methods

	_onDomUpdate(){
		this._splitThrottler();
	}

	_onResize(){
		this._resize();
	}

	//

	_resize(){
		this._splitThrottler();
	}

	// split methods

	_splitText(){

		if(this._isEnabled){

			this._GSAPSplit();
			this._GSAPSplit(); // needs to be doubled due to a bug (TODO: fix)
			this._addClasses();
		}
	}

	_GSAPSplit(){
		if(this._split){ this._split.revert(); }
		this._split = new SplitText(this.$el, {position:'absolute', type:this._options.type});
	}

	_addClasses(){

		let lineIndex = 0;
		let lineWordIndex = 0;
		let totalWordIndex = 0;

		if(this._split.lines && this._split.lines.length > 0){

			for(let i = 0; i<this._split.lines.length; i++){

				let $line = $(this._split.lines[i]);
				$line.addClass('line');

				if(this._options.doubleWrapLine){

					let $lineWrapper = $('<div class="line-wrapper"></div>');
					$lineWrapper.addClass('line-wrapper-' + i);
					$lineWrapper.css({
						position: 'absolute',
						top: $line.css('top'),
						left: $line.css('left'),
						width: $line.css('width'),
						height: $line.css('height'),
					});

					$line.css({
						top: 0,
						left: 0,
					});

					$line.parent().append($lineWrapper);
					$line.remove();
					$lineWrapper.html($line);
				}
			}
		}

		if(this._split.words && this._split.words.length > 0){

			let lastTop = $(this._split.words[0]).offset().top;

			for(let i = 0; i<this._split.words.length; i++){

				let $word = $(this._split.words[i]);
				let chars = $word.children();
				let top = $word.offset().top;

				if(top != lastTop){
					lastTop = top;
					lineWordIndex = 0;
					lineIndex ++;
				}

				let lineClass = 'line-' + lineIndex;
				let lineWordClass = 'line-word-' + lineWordIndex;
				let totalWordClass = 'total-word-' + i;

				$word.addClass('word');
				$word.addClass(lineClass);
				$word.addClass(lineWordClass);
				$word.addClass(totalWordClass);

				for(let k=0; k<chars.length; k++){

					let $char = $(chars[k]);

					$char.addClass('char');
					$char.addClass(lineClass);
					$char.addClass(lineWordClass);
					$char.addClass(totalWordClass);

					// double wrap

					if(this._options.doubleWrapChar){

						let $charWrapper = $('<div class="char-wrapper"></div>');
						$charWrapper.addClass('char-wrapper-' + i);
						$charWrapper.css({
							position: 'absolute',
							top: $char.css('top'),
							left: $char.css('left'),
							width: $char.css('width'),
							height: $char.css('height'),
						});

						$char.css({
							top: 0,
							left: 0,
						});

						$char.parent().append($charWrapper);
						$char.remove();
						$charWrapper.html($char);
					}
				}

				// double wrap

				if(this._options.doubleWrapWord){

					let $wordWrapper = $('<div class="word-wrapper"></div>');
					$wordWrapper.addClass('word-wrapper-' + i);
					$wordWrapper.css({
						position: 'absolute',
						top: $word.css('top'),
						left: $word.css('left'),
						width: $word.css('width'),
						height: $word.css('height'),
					});

					$word.css({
						top: 0,
						left: 0,
					});

					$word.parent().append($wordWrapper);
					$word.remove();
					$wordWrapper.html($word);
				}

				//

				lineWordIndex ++;
				totalWordIndex ++;
			}
		}
	}

	//

	enable(){
		if(!this._isEnabled){
			this._isEnabled = true;
			this._resize();
		}
	}

	disable(){
		if(this._isEnabled){
			this._isEnabled = false;
		}
	}

	revert(){
		this.disable();
		if(this._split){ this._split.revert(); }
	}

	// defaults

	_mergeDefaults(options){

		let modifiedOptions = $.extend({}, options);

		for(let key in modifiedOptions){
			let val = (modifiedOptions[key] === 'undefined') ? null : modifiedOptions[key];
			if(val == undefined || val == null){ modifiedOptions[key] = this._defaults[key]; }
		}

		return $.extend({}, this._defaults, modifiedOptions);
	}
}

module.exports = TextSplitter;
